/* unplugin-vue-components disabled */import { render } from "./BannerList.vue?vue&type=template&id=36f09eda&scoped=true"
import script from "./BannerList.vue?vue&type=script&lang=js"
export * from "./BannerList.vue?vue&type=script&lang=js"

import "./BannerList.vue?vue&type=style&index=0&id=36f09eda&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户上电-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f09eda"]])

export default __exports__